export const width = (): number => {
  return (
    window.innerWidth ||
    (document.documentElement ? document.documentElement.clientWidth : 0) ||
    (document.body ? document.body.clientWidth : 0)
  )
}
